export default __webpack_public_path__ + "static/media/password.e1403add.svg";